export default "__VITE_ASSET__BraaLYaL__"